/**
 * Inizializzazione principale
 */
function getWorkout() {
    const Pageurl = '/pages/the-program';

    if (window.location.pathname.includes(Pageurl)) {
        beeCalc();
        bffAccordion();
        getFeedback();
        const params = new URLSearchParams(window.location.search);
        const programId = params.get('id');
        const EatingPlanId = params.get('e');
        
        // Dati per l'header (uguali per entrambi i tipi)
        const ProgramName = params.get('t');
        const ProgramDate = params.get('d');
        const ProgramOrder = params.get('o');

        $(".plan_type_info").html('ordine '+ ProgramOrder +' - '+ProgramDate );

        if (!programId) return;

        $(".bff-item").off("click").on("click", function() {
            $(".bff-type").removeClass("selected");
            $(this).find(".bff-type").addClass("selected");

            const isFood = $(this).text().toLowerCase().includes('food');

            if (isFood) {
                // Gestione Visibilità Sezioni
                $(".workout-type").hide();
                $("#workout-legend").hide(); // Elimina la legenda workout
                
                $(".food-type").show();
                $("#food-legend").show();    // Mostra la legenda food
                
                initFoodPlan(EatingPlanId);
            } else {
                // Gestione Visibilità Sezioni
                $(".food-type").hide();
                $("#food-legend").hide();    // Nasconde la legenda food
                
                $(".workout-type").show();
                $("#workout-legend").show(); // Mostra la legenda workout
                
                renderWeekSelector(programId);
                fetchWeekData(programId, 1);
            }
        });

        $(".bff-item").first().click();
    }
}

/**
 * LOGICA WORKOUT: Settimane e Chiamate AJAX
 */
function renderWeekSelector(programId) {
    const $container = $(".bff-calendar_container");
    
    // Nascondiamo il cibo e mostriamo gli esercizi
    $(".food-type").hide();
    $("#exercises-container").show();

    $container.empty();
    
    const $weekWrapper = $('<div class="weeks-pills-container"><ul class="weeks-pills-list"></ul></div>');
    $container.append($weekWrapper);
    $container.append('<ul class="days-pills-list"></ul>');

    for (let w = 1; w <= 4; w++) {
        $('<li>')
            .addClass('week-pill')
            .toggleClass('active', w === 1)
            .text(`Week ${w}`)
            .on('click', function () {
                if ($(this).hasClass('active')) return;
                $('.week-pill').removeClass('active');
                $(this).addClass('active');
                fetchWeekData(programId, w);
            })
            .appendTo($weekWrapper.find('ul'));
    }
}

function fetchWeekData(programId, week) {
    const $daySelector = $(".bff-calendar_container ul").not(".weeks-pills-list");
    const $workoutContainer = $('#exercises-container');

    $daySelector.empty();
    $workoutContainer.html('<p class="text-center">Caricamento allenamenti...</p>');

    const settings = {
        "url": `https://backend-main-zu9ki2.laravel.cloud/api/shopify/show_plan?plan_id=${programId}&week=${week}`,
        "method": "POST",
        "headers": {
            "Accept": "application/json",
            "Authorization": "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxOSIsImp0aSI6IjE5N2I2OTg3OTY3ZjNlYWQ0YTdjMGFkMTIzMzJjMmFkMzJmZDUxMmQzNWI4ODg5MTAzNTE2ODU3NWIzY2YwZmExYWE2YWQxODU3NzliNjMwIiwiaWF0IjoxNzcwOTgwMjIxLjMxNDkzOCwibmJmIjoxNzcwOTgwMjIxLjMxNDkzOSwiZXhwIjoxODAyNTE2MjIxLjMwOTIzOSwic3ViIjoiMTkiLCJzY29wZXMiOlsiKiJdfQ.ftCrIpw4LsnjUzpDWzciH0h_jJjJoLbGpqeoOrFSrrg3ldAR1vGTP50rwvENLmcflo_G9Woo4yC4gHQ42FY0jbIx9WUcn9p0BPxCqmQLkHHjL3E0__Ddr28_9RWiMC24ybrHgqLeJSvsmHKLLt1Cqv_zNJddS4JgnO0PcRPVeML9Xb0m3AD-Hq0RH4T9cGDLiERABAjR-5ANy2Iu8ESafBGzudp8tw3Ad2sBNLUsZTRRZ_PLOab_-RgPID2VbDicFWRuOlvYDNiYlplDSJTeTeW6wjmwOYel5j-AK53QKtr99iYzKDqqaV4hU3yz-YefLLCtIkP0UBJMgiGirohCHzTCEsFdCDwpyXstT2tR6ePpdpOyHgcE0Z6pocgoY4z9U0Tic1jqE7E5DxBL37rcMABItZMtsAc7pDiJ_6tcDMLPHu4IVVtaUn-Erckf5HKw2kFEGxjye1DbwHEowothntcOTWX2RUaN5Sd-5nJuG2oyQUyfP-kAkSW4rytJ_h8o1cXQGhJt22sg3kAe1-o26ZU74XYF_n7NQ3PQ-91IIEXoAES_-RGM6e4lu7-BWS76nYDuL1hSvsBvcgTjUcEDIHbtstHGrWL8ihMaKAB3RknHHNjmUtnu-tjv-Ce3q7posCbz67XdulWuCTQXayw8DoefkY7sIjiNcIKNzdwNFns"
        }
    };

    $.ajax(settings).done(function (response) {
        var creationDate = response.date_start;  //2026-01-13T10:41:29.000000Z 
        var dateSplit = creationDate.split('-');
        beeCalc(response.plan_type_name);
        $(".plan_name").html(response.plan_type_name+'<span>'+response.diet+'</span>');
        $(".plan_type_info").text('ordine '+ response.shopify_order_id +' - '+dateNormalize(dateSplit[1],dateSplit[0]));
        dietSostitution(response.diet_key);
        const validDays = response.data.filter(item => item.course.exercises && item.course.exercises.length > 0);

        if (validDays.length === 0) {
            $workoutContainer.html('<p class="text-center">Nessun allenamento previsto.</p>');
            return;
        }

        validDays.forEach((item, i) => {
            $('<li>')
                .text(`Day ${i + 1}`)
                .addClass('day-btn')
                .on('click', function () {
                    $('.day-btn').removeClass('active');
                    $(this).addClass('active');
                    renderDay(i, validDays);
                })
                .appendTo($daySelector);
        });

        $daySelector.find('li').first().addClass('active');
        renderDay(0, validDays);

    }).fail(function () {
        $workoutContainer.html('<p class="text-center">Errore nel caricamento.</p>');
    });
}

/**
 * LOGICA WORKOUT: Costruzione del DOM
 */
const renderDay = (index, validDays) => {
    const exercises = validDays[index].course.exercises;
    const $container = $('#exercises-container').empty();

    let $currentWrapper = null;
    let $currentInner = null;

    exercises.forEach((ex, i) => {
        const title = ex.title ? ex.title.toLowerCase() : "";
        const isRiscaldamento = title.includes("riscaldamento");
        const isStretching = title.includes("stretching");

        if (isRiscaldamento) {
            $container.append(workoutTemplate("SingleWrapper", ex));
            $container.append(workoutTemplate("NextSeparator", { text: "Go!!!", finish: false }));
            $currentWrapper = null;
        }
        else if (isStretching) {
            $container.append(workoutTemplate("NextSeparator", { text: "Great!!!", finish: true }));
            $container.append(workoutTemplate("SingleWrapper", ex));
            $currentWrapper = null;
        }
        else {
            if (ex.is_group) {
                if ($currentWrapper) $container.append(workoutTemplate("NextSeparator", { text: "Again!", finish: false }));
                const groupHtml = workoutTemplate("GroupHeader", ex);
                $currentWrapper = $(groupHtml);
                $currentInner = $currentWrapper.find('.workout-inner');
                $container.append($currentWrapper);
            }
            else if (ex.group_code !== null) {
                const itemHtml = workoutTemplate("ExerciseItem", ex);
                if ($currentInner) $currentInner.append(itemHtml);
            }
            else {
                const isNewBlock = i > 0 && (exercises[i - 1].group_code !== null || exercises[i - 1].is_group);
                if (!$currentWrapper || isNewBlock) {
                    if ($currentWrapper) $container.append(workoutTemplate("NextSeparator", { text: "Again!", finish: false }));
                    $currentWrapper = $('<div class="bff-workout_wrapper"></div>');
                    $container.append($currentWrapper);
                    $currentInner = null;
                }
                $currentWrapper.append(workoutTemplate("ExerciseItem", ex));
            }
        }
    });
};

function workoutTemplate(type, data) {
    const formatDuration = (s) => {
        if (!s || s <= 0) return '';
        if (s < 60) return `${s} sec`;
        const mins = Math.floor(s / 60);
        const secs = s % 60;
        return secs > 0 ? `${mins}m ${secs}s` : `${mins} min`;
    };

    let infoText = "";
    if (data.repetitions) {
        infoText = `${data.repetitions} reps`;
    } else if (data.duration) {
        infoText = formatDuration(data.duration);
    }

    const isRest = data.title && data.title.toLowerCase() === "rest";

    if (isRest) {
        return `
            <div class="workout-item rest">
                <span class="workout-name">${data.title}</span>
                ${infoText ? `<span class="workout-info">${infoText}</span>` : ''}
            </div>`;
    }

    const videoId = getYouTubeID(data.video_url, "false");
    const itemContent = `
        <div class="workout-item">
            <a href="/pages/workout?id=${data.code}">
                <span class="workout-preview" style="background-image: url('https://img.youtube.com/vi/${data.video_url}/maxresdefault.jpg');"></span>
                <div class="workout-infos">
                    <span class="workout-name" style="font-weight: bold; display: block;">${data.title}</span>
                    ${data.extra ? `<div class="workout-extra" style="font-size: 12px; font-style: italic; color: #0000000; margin-top: 2px;">${data.extra}</div>` : ''}
                    ${infoText ? `<span class="workout-info" style="display: block; margin-top: 4px; font-size: 13px; color: #555;">${infoText}</span>` : ''}
                </div>
                <img class="arrow" src="https://cdn.shopify.com/s/files/1/0539/0627/6534/files/arrow-down.png?v=1625522446"/>
            </a>
        </div>`;

    switch (type) {
        case "SingleWrapper": return `<div class="bff-workout_wrapper">${itemContent}</div>`;
        case "GroupHeader": return `<div class="bff-workout_wrapper"><div class="workout-group"><h5>${data.title} <img class="scrollTo" src="https://cdn.shopify.com/s/files/1/0539/0627/6534/files/information_question.png?v=1767647338"></h5><span>${data.extra || ''}</span></div><div class="workout-inner"></div></div>`;
        case "ExerciseItem": return itemContent;
        case "NextSeparator": return `<div class="next-workout${data.finish ? ' finish' : ''}"><span>${data.text}</span></div>`;
        default: return '';
    }
}
/**
 * LOGICA FOOD: Svuota e prepara l'area Food
 */
function initFoodPlan(EatingPlanId) {
    const $calendarContainer = $(".bff-calendar_container");
    
    // Svuota solo il calendario (settimane/giorni), non tutto il piano!
    $calendarContainer.empty();

    // Crea la struttura delle settimane
    const $weekWrapper = $('<div class="weeks-pills-container"><ul class="weeks-pills-list"></ul></div>');
    $calendarContainer.append($weekWrapper);
    
    // Crea la lista dei giorni se non esiste
    if ($calendarContainer.find(".days-pills-list").length === 0) {
        $calendarContainer.append('<ul class="days-pills-list"></ul>');
    }

    for (let w = 1; w <= 4; w++) {
        $('<li>')
            .addClass('week-pill')
            .toggleClass('active', w === 1)
            .text(`Week ${w}`)
            .on('click', function () {
                $('.week-pill').removeClass('active');
                $(this).addClass('active');
                getFood(EatingPlanId, w);
            })
            .appendTo($weekWrapper.find('ul'));
    }

    // Carica la prima settimana
    getFood(EatingPlanId, 1);
}
function getFood(id,week){
    const $daysUl = $(".bff-calendar_container ul").not(".weeks-pills-list");
    // Puntiamo all'ID specifico dell'area contenuto food
    const $foodContainer = $("#dishes-container"); 

    $daysUl.empty();
    $foodContainer.html('<p class="text-center">Caricamento...</p>');

    const settings = {
        "url": `https://backend-main-zu9ki2.laravel.cloud/api/shopify/show_food_plan?eating_plan_id=${id}&week=${week}`,
        "method": "POST",
        "headers": {
            "Accept": "application/json",
            "Authorization": "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxOSIsImp0aSI6IjE5N2I2OTg3OTY3ZjNlYWQ0YTdjMGFkMTIzMzJjMmFkMzJmZDUxMmQzNWI4ODg5MTAzNTE2ODU3NWIzY2YwZmExYWE2YWQxODU3NzliNjMwIiwiaWF0IjoxNzcwOTgwMjIxLjMxNDkzOCwibmJmIjoxNzcwOTgwMjIxLjMxNDkzOSwiZXhwIjoxODAyNTE2MjIxLjMwOTIzOSwic3ViIjoiMTkiLCJzY29wZXMiOlsiKiJdfQ.ftCrIpw4LsnjUzpDWzciH0h_jJjJoLbGpqeoOrFSrrg3ldAR1vGTP50rwvENLmcflo_G9Woo4yC4gHQ42FY0jbIx9WUcn9p0BPxCqmQLkHHjL3E0__Ddr28_9RWiMC24ybrHgqLeJSvsmHKLLt1Cqv_zNJddS4JgnO0PcRPVeML9Xb0m3AD-Hq0RH4T9cGDLiERABAjR-5ANy2Iu8ESafBGzudp8tw3Ad2sBNLUsZTRRZ_PLOab_-RgPID2VbDicFWRuOlvYDNiYlplDSJTeTeW6wjmwOYel5j-AK53QKtr99iYzKDqqaV4hU3yz-YefLLCtIkP0UBJMgiGirohCHzTCEsFdCDwpyXstT2tR6ePpdpOyHgcE0Z6pocgoY4z9U0Tic1jqE7E5DxBL37rcMABItZMtsAc7pDiJ_6tcDMLPHu4IVVtaUn-Erckf5HKw2kFEGxjye1DbwHEowothntcOTWX2RUaN5Sd-5nJuG2oyQUyfP-kAkSW4rytJ_h8o1cXQGhJt22sg3kAe1-o26ZU74XYF_n7NQ3PQ-91IIEXoAES_-RGM6e4lu7-BWS76nYDuL1hSvsBvcgTjUcEDIHbtstHGrWL8ihMaKAB3RknHHNjmUtnu-tjv-Ce3q7posCbz67XdulWuCTQXayw8DoefkY7sIjiNcIKNzdwNFns"
        }
    };

    $.ajax(settings).done(function (response) {
        let arr_eating = [];

        // Costruiamo l'array
        response.data.forEach((dayEntry, index) => {
            arr_eating.push({
                day: "Day " + (index + 1),
                menu: dayEntry.eating_menu
            });

            // Creiamo il bottone
            const $dayBtn = $('<li>')
                .text(`Day ${index + 1}`)
                .addClass('day-btn')
                .attr('data-index', index);
            
            $dayBtn.on('click', function () {
                $('.day-btn').removeClass('active');
                $(this).addClass('active');
                
                // Forza la conversione in intero
                const idx = parseInt($(this).attr('data-index'));
                renderFoodDay(idx, arr_eating);
            });

            $dayBtn.appendTo($daysUl);
        });

        // ESECUZIONE IMMEDIATA
        if (arr_eating.length > 0) {
            $daysUl.find('li').first().addClass('active');
            renderFoodDay(0, arr_eating);
        }

    }).fail(function(err) {
        $foodContainer.html('<p class="text-center">Errore di rete.</p>');
    });
}
function renderFoodDay(index, dataArray) {
    // Puntiamo a #dishes-container invece di un bff-container generico
    const $container = $("#dishes-container");

    if (!$container.length) {
        console.error("ERRORE: #dishes-container non trovato!");
        return;
    }

    $container.empty();
    
    const menu = dataArray[index].menu;
    const meals = ['breakfast', 'morning_snack', 'lunch', 'afternoon_snack', 'dinner'];
    
    meals.forEach(mealKey => {
        const meal = menu[mealKey];
        if (meal && meal.dishes && meal.dishes.main && meal.dishes.main.length > 0) {
            const nomePiatto = meal.dishes.main[0].name;
            const labelPasto = meal.label;
            $container.append(eatingPlanTemplate(labelPasto, meal.dishes.main));
        }
    });
}
function eatingPlanTemplate(label, dishes){
    var template = "<div class='dish_type'><h4>"+label+"</h4><ul class='diet_sostitution'>";
                        dishes.forEach(function(dish){
                            template += "<li>"+dish.name+"</li>";
                        })
    template += "</ul></div>";    
    return template;
}

/**
 * UTILITY
 */
function getYouTubeID(url, thumb) {
    // if (!url) return "UiG3X_n_Dx4";
    // const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    // const match = url.match(regExp);
    // return (match && match[2].length === 11) ? match[2] : "UiG3X_n_Dx4";
    if (thumb == false) {
        res = 'https://www.youtube.com/embed/'+url+'?enablejsapi=1&rel=0&controls=1&modestbranding=1';
        return res;
    }else{
        res = 'https://img.youtube.com/vi/'+url+'/maxresdefault.jpg';
    }
}
$(document).on('click', '.scrollTo', function(e) {
        // Impedisce il comportamento predefinito del link
        e.preventDefault();

        // Definisci l'oggetto di destinazione
        var target = $('#workout-legend');

        // Controlla se l'elemento esiste per evitare errori
        if (target.length) {
            $('html, body').animate({
                scrollTop: target.offset().top
            }, 800); // 800 è la durata in millisecondi (0.8 secondi)
}});
function bffAccordion(){
    const trigger = $(".accordion-trigger");
    const content = $(".accordion-content");
    if (trigger.length) {
        content.hide();

        trigger.each(function(){
            $(this).append('<span class="trigger-action">+</span>');
        });

        trigger.on("click",function(){
            $(this).next().toggle();
            $(this).find('.trigger-action').toggleClass('active');
        });
    }
}
function dietSostitution(diet){
    var template;
    const target = $(".diet_sostitution_container");
    switch(diet) {
        case 'vegano':
            template = '<strong class="diet_sostitution_title">UOVA</strong><ul class="diet_sostitution"><li>N. 2 (1+2 albumi)</li></ul><strong class="diet_sostitution_title">PASTA E CEREALI</strong><ul class="diet_sostitution"><li><strong>Cereali integrali:</strong> Pasta integrale, riso integrale o riso venere, couscous, orzo, farro, miglio, quinoa o misti</li><li>Conditi con sughi semplici: sugo al pomodoro, verdure, in bianco con un cucchiaino di olio d\'oliva o zafferano OPPURE in associazione alla proteina indicata (esempio: legumi o formaggio)</li></ul><strong class="diet_sostitution_title">VERDURA</strong><ul class="diet_sostitution"><li>Contorno di verdure di stagione cotte o crude (se assunte crude prima del pasto possono aiutare a moderare il senso di fame!!)</li><li>Minestrone o passati di verdura possono EVENTUALMENTE sostituire il contorno se preparati senza legumi, né patate oppure acquista MINESTRONE LEGGEREZZA di Orogel tra i surgelati.</li><li><strong>Verdure che costituiscono una porzione di cibo ricco di calcio:</strong> rucola*, cime di rapa*, cicoria*, cardi*, broccolo*, carciofo*, radicchio*, indivia*.</li></ul><strong class="diet_sostitution_title">LEGUMI E CIBI RICCHI DI PROTEINE</strong><ul class="diet_sostitution"><li><strong>Legumi secchi o surgelati o confezionati:</strong> Fagioli, lenticchie, piselli, fave o ceci</li><li>Tofu o tempeh (non più di 2/3 volte a settimana)</li><li>Seitan (max 1 volta a settimana)</li></ul><strong class="diet_sostitution_title">PATATE</strong><ul class="diet_sostitution"><li>In sostituzione a pane o pasta massimo 1 volta alla settimana</li></ul><strong class="diet_sostitution_title">PANE</strong><ul class="diet_sostitution"><li>Pane INTEGRALE o gallette di crusca di avena o ai 5 cereali o di kamut oppure fette Wasa</li></ul><strong class="diet_sostitution_title">CONDIMENTI</strong><ul class="diet_sostitution"><li>OLIO EXTRAVERGINE DI OLIVA per tutte le preparazioni della giornata</li></ul><strong class="diet_sostitution_title">FRUTTA</strong><ul class="diet_sostitution"><li>N. 2 porzioni al giorno tutta la frutta di stagione (porzione: 1 frutto di medie dimensioni = 150/200 g; esempio una MELA)</li></ul><strong class="diet_sostitution_title">EXTRA | OGNI TANTO CI VUOLE!</strong><ul class="diet_sostitution"><li>Una volta alla settimana concediti un piccolo extra! Che sia una pizza, un gelato o un croissant! Mi raccomando cerca di associarlo ad un giorno di allenamento!</li></ul>';
            target.append(template);
            break;
        case 'default':
            template = '<strong class="diet_sostitution_title">CARNE</strong><ul class="diet_sostitution"><li><strong>Carne bianca:</strong> pollo, tacchino, coniglio, faraona senza pelle</li><li><strong>Carne rossa:</strong> cavallo, maiale magro, manzo magro, vitello magro</li><li><strong>Affettati:</strong> bresaola, fesa di tacchino/pollo, prosciutto cotto sgrassato prosciutto crudo magro</li></ul><strong class="diet_sostitution_title">PESCE</strong><ul class="diet_sostitution"><li><strong>Pesci magri:</strong> merluzzo, sogliola, coda di rospo, trota, rombo, cernia, luccio, nasello, orata, spigola, triglia</li><li><strong>Pesci semigrassi (ad alto contenuto di Omega-3):</strong> sgombro, tonno, salmone, pesce azzurro</li><li><strong>Conservato:</strong> tonno sott\'olio (scatoletta piccola), tonno al naturale o sgombro (scatoletta grande)</li></ul><strong class="diet_sostitution_title">UOVA</strong><ul class="diet_sostitution"><li>Puoi usare anche solo l\'albume.</li></ul><strong class="diet_sostitution_title">FORMAGGI</strong><ul class="diet_sostitution"><li>ricotta, fiocchi di latte, magro spalmabile, crescenza, mozzarella, primo sale, parmigiano, feta, Philadelphia light</li></ul><strong class="diet_sostitution_title">PASTA E CEREALI</strong><ul class="diet_sostitution"><li><strong>Cereali integrali:</strong> riso integrale, riso venere, orzo, farro, miglio, quinoa</li><li>Condisci con sughi semplici come sugo al pomodoro, verdure, in bianco con un cucchiaino di olio di oliva o zafferano oppure in associazione alla proteina indicata</li></ul><strong class="diet_sostitution_title">PANE E PATATE</strong><ul class="diet_sostitution"><li><strong>Pane:</strong> integrale, gallette di crusca, di avena, 5 cereali, kamut, fette Wasa integrali</li><li><strong>Patate:</strong> lesse in sostituzione al pane o pasta</li></ul><strong class="diet_sostitution_title">VERDURA</strong><ul class="diet_sostitution"><li>contorno di verdure di stagione cotte o crude</li><li>Minestrone o passati di verdure possono eventualmente sostituire il contorno se preparati senza legumi e senza patate.</li></ul><strong class="diet_sostitution_title">LEGUMI</strong><ul class="diet_sostitution"><li>fagioli, lenticchie, piselli, fave, ceci.</li></ul><strong class="diet_sostitution_title">FRUTTA</strong><ul class="diet_sostitution"><li>frutta di stagione</li></ul><strong class="diet_sostitution_title">EXTRA | OGNI TANTO CI VUOLE!</strong><ul class="diet_sostitution"><li>Una volta alla settimana concediti un piccolo extra! Che sia una pizza, un gelato o un croissant! Mi raccomando cerca di associarlo ad un giorno di allenamento!</li></ul>'
            target.append(template);
            break;
        case 'vegetariano':  
            template = '<strong class="diet_sostitution_title">UOVA</strong><ul class="diet_sostitution"><li>N. 2 (1+2 albumi)</li></ul><strong class="diet_sostitution_title">PASTA E CEREALI</strong><ul class="diet_sostitution"><li><strong>Cereali integrali:</strong> riso integrale, riso venere, orzo, farro, miglio, quinoa</li><li>Condisci con sughi semplici come sugo al pomodoro, verdure, in bianco con un cucchiaino di olio di oliva o zafferano oppure in associazione alla proteina indicata</li></ul><strong class="diet_sostitution_title">PESCE</strong><ul class="diet_sostitution"><li><strong>Pesci magri:</strong> merluzzo, sogliola, coda di rospo, trota, rombo, cernia, luccio, nasello, orata, spigola, triglia</li><li><strong>Pesci semigrassi (ad alto contenuto di Omega-3):</strong> sgombro, tonno, salmone, pesce azzurro</li><li><strong>Conservato:</strong> tonno sott\'olio (scatoletta piccola), tonno al naturale o sgombro (scatoletta grande)</li></ul><strong class="diet_sostitution_title">VERDURA</strong><ul class="diet_sostitution"><li>contorno di verdure di stagione cotte o crude</li><li>Minestrone o passati di verdure possono eventualmente sostituire il contorno se preparati senza legumi e senza patate.</li></ul><strong class="diet_sostitution_title">FRUTTA</strong><ul class="diet_sostitution"><li>frutta di stagione</li></ul><strong class="diet_sostitution_title">FORMAGGI</strong><ul class="diet_sostitution"><li>ricotta, fiocchi di latte, magro spalmabile, crescenza, mozzarella, primo sale, parmigiano, feta, Philadelphia light</li></ul><strong class="diet_sostitution_title">PANE E PATATE</strong><ul class="diet_sostitution"><li><strong>Pane:</strong> integrale, gallette di crusca, di avena, 5 cereali, kamut, fette Wasa integrali</li><li><strong>Patate:</strong> lesse in sostituzione al pane o pasta</li></ul><strong class="diet_sostitution_title">LEGUMI</strong><ul class="diet_sostitution"><li>fagioli, lenticchie, piselli, fave, ceci.</li></ul><strong class="diet_sostitution_title">EXTRA | OGNI TANTO CI VUOLE!</strong><ul class="diet_sostitution"><li>Una volta alla settimana concediti un piccolo extra! Che sia una pizza, un gelato o un croissant! Mi raccomando cerca di associarlo ad un giorno di allenamento!</li></ul>';  
            target.append(template);
            break;
    }
}
function dateNormalize(monthNumber, year) {
    const months = [
        "Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
        "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"
    ];
    var monthName = months[Number(monthNumber) - 1];
    if (!monthName) return "Mese non valido";
    return monthName + " " + year;
}
function beeCalc(planTypeName){
    const { height, weight, bday } = window.customerDataConfig || {};
    var nascita = bday;
    var altezza = Number(height);
    var peso = Number(weight);
    var target = $(".grammature");
    console.log("PESO: "+weight)


    const bmi = (()=>{
        altezzabmi = altezza / 100;
  
        console.log(altezzabmi );
        console.log(peso);
        var mybmi= peso / (altezzabmi * altezzabmi);
        
        return  Math.round(mybmi)
            
    })();

    function calculateAge(birthdate) {
        var today = new Date();
        var birthdateParts = birthdate.split("/");
        var birthdate = new Date(birthdateParts[2], birthdateParts[1] - 1, birthdateParts[0]);
        var age = today.getFullYear() - birthdate.getFullYear();
        var m = today.getMonth() - birthdate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthdate.getDate())) {
            age--;
        }
        console.log("eta" + age);
        return age;
    }

    const  bee = (()=>{
        mybee=Math.round(
        655.095 + (9.5634 * peso) + (1.849 * altezza) - (4.6756 * calculateAge(nascita)));
        return mybee
    })()

    const getGrammaturaData = (bmi, bee) => {
    // 1. Logica BMI: Fuori soglia o caso speciale 2000kcal
    if (bmi > 24.9) {
        return null;
    }

    if (bmi < 19.5) {
        return 'https://cdn.shopify.com/s/files/1/0539/0627/6534/files/2000kcal.pdf';
    }

    // 2. Mapping BEE: Range 19.5 - 22.9
    const beeMap = [
        { min: 1151, max: 1250, kcal: 1200 },
        { min: 1251, max: 1350, kcal: 1300 },
        { min: 1351, max: 1450, kcal: 1400 },
        { min: 1451, max: 1550, kcal: 1500 },
        { min: 1551, max: 1650, kcal: 1600 },
        { min: 1651, max: 1750, kcal: 1700 },
        { min: 1751, max: 1850, kcal: 1800 }
    ];

    const match = beeMap.find(range => bee >= range.min && bee <= range.max);

    // 3. Output
    return match 
        ? `https://cdn.shopify.com/s/files/1/0539/0627/6534/files/${match.kcal}kcal.pdf` 
        : null;
};
    const url = getGrammaturaData(bmi, bee);
    if (planTypeName == 'Pregnancy') {
         target.html("<span style='font-weight: bold;'>Per tutti i piani Pregnancy non sono disponibili grammature. Per obiettivi specifici o dubbi, ti suggeriamo di consultare un nutrizionista. </span>");       
    }else{
        if (url) {
            target.html("<a href='"+url+"' style='text-decoration: unedline; font-weight: bold;'>Visualizza la tabella delle grammature</a>");
        }else{
            target.html("<span style='font-weight: bold;'>Il calcolo prodotto dal tuo BMI e BEE non permette di suggerire delle grammature. Per obiettivi specifici o dubbi, ti suggeriamo di consultare un nutrizionista. </span>");
        }        
    }
        // switch (result.status) {
        //     case 'OK':
        //         target.html("<a href='"+result.url+"' target='_blank' style='font-weight: bold; text-decoration: underline;'>Scarica Tabella Grammature</a>");
        //         break;
                
        //     case 'LIGHT-UNDERWEIGHT':
        //         target.html("Da quanto inserito emerge un leggero sottopeso, per tanto nel tuo caso non saranno inserite le grammature.").removeAttr("href");
        //         break;
        //     case 'LIGHT-OVERWEIGHT':
        //         target.html("Da quanto inserito emerge un leggero sovrappeso, per tanto nel tuo caso non saranno inserite le grammature.").removeAttr("href");
        //         break;           
        //     case 'OVERWEIGHT':
        //         target.html("Da quanto inserito emerge una situazione di sovrappeso, per tanto nel tuo caso non saranno inserite le grammature.").removeAttr("href");
        //         break;
                
        //     case 'BEE_OUT_OF_RANGE':
        //         target.html("Valori BEE fuori dai parametri standard");
        //         break;

        //     default:
        //         target.html("Dati non disponibili");
        // }
}
function getFeedback(){
    //Feedback
    var settings = {
        "url": "https://backend-main-zu9ki2.laravel.cloud/api/shopify/feedback/status",
        "method": "POST",
        "timeout": 0,
        "contentType": "application/json",
        "headers": {
            "Accept": "application/json",
            "Authorization": "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxOSIsImp0aSI6IjE5N2I2OTg3OTY3ZjNlYWQ0YTdjMGFkMTIzMzJjMmFkMzJmZDUxMmQzNWI4ODg5MTAzNTE2ODU3NWIzY2YwZmExYWE2YWQxODU3NzliNjMwIiwiaWF0IjoxNzcwOTgwMjIxLjMxNDkzOCwibmJmIjoxNzcwOTgwMjIxLjMxNDkzOSwiZXhwIjoxODAyNTE2MjIxLjMwOTIzOSwic3ViIjoiMTkiLCJzY29wZXMiOlsiKiJdfQ.ftCrIpw4LsnjUzpDWzciH0h_jJjJoLbGpqeoOrFSrrg3ldAR1vGTP50rwvENLmcflo_G9Woo4yC4gHQ42FY0jbIx9WUcn9p0BPxCqmQLkHHjL3E0__Ddr28_9RWiMC24ybrHgqLeJSvsmHKLLt1Cqv_zNJddS4JgnO0PcRPVeML9Xb0m3AD-Hq0RH4T9cGDLiERABAjR-5ANy2Iu8ESafBGzudp8tw3Ad2sBNLUsZTRRZ_PLOab_-RgPID2VbDicFWRuOlvYDNiYlplDSJTeTeW6wjmwOYel5j-AK53QKtr99iYzKDqqaV4hU3yz-YefLLCtIkP0UBJMgiGirohCHzTCEsFdCDwpyXstT2tR6ePpdpOyHgcE0Z6pocgoY4z9U0Tic1jqE7E5DxBL37rcMABItZMtsAc7pDiJ_6tcDMLPHu4IVVtaUn-Erckf5HKw2kFEGxjye1DbwHEowothntcOTWX2RUaN5Sd-5nJuG2oyQUyfP-kAkSW4rytJ_h8o1cXQGhJt22sg3kAe1-o26ZU74XYF_n7NQ3PQ-91IIEXoAES_-RGM6e4lu7-BWS76nYDuL1hSvsBvcgTjUcEDIHbtstHGrWL8ihMaKAB3RknHHNjmUtnu-tjv-Ce3q7posCbz67XdulWuCTQXayw8DoefkY7sIjiNcIKNzdwNFns"
        },
        "data": JSON.stringify({
            cid: workoutConfig?.cid,
            sig: workoutConfig?.sig,
        }),
    };
    $.ajax(settings)
    .done(function (response) {
    if (response.can_submit == false) {
        $(".feedback-banner").remove();
    }
    })

let selectedRating = $('.reaction-button--active').data('value');

$('.reaction-button').on('click', function() {
    $('.reaction-button').removeClass('reaction-button--active');
    $(this).addClass('reaction-button--active');
    
    selectedRating = $(this).data('value');
});

$(document).on('click', '.feedback-banner__submit-group .bff-btn', function(e) {
    e.preventDefault();

$('.feedback-errors').hide();

let isConsentChecked = $('.feedback-banner__checkbox').is(':checked');
if (!isConsentChecked) {
    $('.feedback-errors').fadeIn();
    return;
}

let messageText = $('.feedback-banner__textarea').val().trim();

    var settings = {
        "url": "https://backend-main-zu9ki2.laravel.cloud/api/shopify/feedback/submit",
        "method": "POST",
        "timeout": 0,
        "contentType": "application/json",
        "headers": {
            "Accept": "application/json",
            "Authorization": "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxOSIsImp0aSI6IjE5N2I2OTg3OTY3ZjNlYWQ0YTdjMGFkMTIzMzJjMmFkMzJmZDUxMmQzNWI4ODg5MTAzNTE2ODU3NWIzY2YwZmExYWE2YWQxODU3NzliNjMwIiwiaWF0IjoxNzcwOTgwMjIxLjMxNDkzOCwibmJmIjoxNzcwOTgwMjIxLjMxNDkzOSwiZXhwIjoxODAyNTE2MjIxLjMwOTIzOSwic3ViIjoiMTkiLCJzY29wZXMiOlsiKiJdfQ.ftCrIpw4LsnjUzpDWzciH0h_jJjJoLbGpqeoOrFSrrg3ldAR1vGTP50rwvENLmcflo_G9Woo4yC4gHQ42FY0jbIx9WUcn9p0BPxCqmQLkHHjL3E0__Ddr28_9RWiMC24ybrHgqLeJSvsmHKLLt1Cqv_zNJddS4JgnO0PcRPVeML9Xb0m3AD-Hq0RH4T9cGDLiERABAjR-5ANy2Iu8ESafBGzudp8tw3Ad2sBNLUsZTRRZ_PLOab_-RgPID2VbDicFWRuOlvYDNiYlplDSJTeTeW6wjmwOYel5j-AK53QKtr99iYzKDqqaV4hU3yz-YefLLCtIkP0UBJMgiGirohCHzTCEsFdCDwpyXstT2tR6ePpdpOyHgcE0Z6pocgoY4z9U0Tic1jqE7E5DxBL37rcMABItZMtsAc7pDiJ_6tcDMLPHu4IVVtaUn-Erckf5HKw2kFEGxjye1DbwHEowothntcOTWX2RUaN5Sd-5nJuG2oyQUyfP-kAkSW4rytJ_h8o1cXQGhJt22sg3kAe1-o26ZU74XYF_n7NQ3PQ-91IIEXoAES_-RGM6e4lu7-BWS76nYDuL1hSvsBvcgTjUcEDIHbtstHGrWL8ihMaKAB3RknHHNjmUtnu-tjv-Ce3q7posCbz67XdulWuCTQXayw8DoefkY7sIjiNcIKNzdwNFns"
        },
        "data": JSON.stringify({
            cid: workoutConfig?.cid,
            sig: workoutConfig?.sig,
            rating: parseInt(selectedRating),
            message: messageText
        }),
    };

    $.ajax(settings)
    .done(function (response) {
            $('.feedback-banner').addClass('feedback-banner-hidden');
            $('#feedback-success-toast').addClass('show');
            setTimeout(function() {
                $('#feedback-success-toast').removeClass('show');
            }, 3000);
            $('.feedback-banner__textarea').val('');
            $('.feedback-banner__checkbox').prop('checked', false);
        })
        .fail(function() {
            alert("Errore durante l'invio del feedback. Riprova.");
        });
    }); 
}